import { INIT_CLIENT, INIT_CLIENT_SUCCESS } from "../../constants/ActionTypes";
import { formatLanguageCode } from "../../utils/helpers";
import { store } from "../index";
import { createStorefrontApiClient } from "@shopify/storefront-api-client";

/**
 * Init shopify client
 * @returns
 */
export const initClient = () => {
  return (dispatch, getState) => {
    dispatch({
      type: INIT_CLIENT,
    });
    return new Promise(resolve => {
      const { currentLanguage } = getState().common;
      const formattedLanguage = formatLanguageCode(currentLanguage);
      const client = createStorefrontApiClient({
        storeDomain: getCurrentStoreDomain(),
        apiVersion: "2025-04",
        publicAccessToken: getStorefrontAccessToken(),
        language: formattedLanguage,
      });
      dispatch({
        type: INIT_CLIENT_SUCCESS,
        payload: client,
      });
      resolve(client);
    });
  };
};

/**
 * Get current store domain
 * @returns {string}
 */
const getCurrentStoreDomain = () => {
  return store.getState().common.currentLanguage === "fr-ca" ||
    store.getState().common.currentLanguage === "en-ca"
    ? process.env.SHOPIFY_CA_STOREFRONT_DOMAIN
    : process.env.SHOPIFY_US_STOREFRONT_DOMAIN;
};

/**
 * Get storefront access token
 * @returns {string}
 */
const getStorefrontAccessToken = () => {
  return store.getState().common.currentLanguage === "fr-ca" ||
    store.getState().common.currentLanguage === "en-ca"
    ? process.env.SHOPIFY_CA_STOREFRONT_TOKEN
    : process.env.SHOPIFY_US_STOREFRONT_TOKEN;
};
